<template>
  <div id="add-option">
    <ipub-model :title="params.id?'Edit Country':'Add Option'"
                width="560px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="publisher-country-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="code"
                        v-if="params.code"
                        label="Code">
          <ipub-input placeholder=""
                      disabled
                      v-model.trim="params.code" />
        </ipub-form-item>
        <ipub-form-item prop="name"
                        label="Counrty Name">
          <ipub-input placeholder="Enter Counrty Name"
                      @blur="queryOption"
                      v-model.trim="params.name" />
        </ipub-form-item>
        <ipub-form-item prop="otherName"
                        label="Other Name">
          <ipub-input placeholder="Enter Other Name"
                      v-model.trim="params.otherName" />
        </ipub-form-item>
      </ipub-form>
      <div slot="footer">
        <ipub-button plain
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="cancel">Cancel</ipub-button>
        <ipub-button type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm()">Save</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { settingCountry } from '@/api/setting'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: Object,
      default () { return {} }
    }
  },
  data () {
    return {
      params: {
        enabled: true
      },
      rules: {}
    }
  },
  watch: {
    isVisable (val) {
      if (val) {
        this.params = JSON.parse(JSON.stringify(this.inputData))
      }
    }
  },
  mounted () {
    this.getRules()
  },

  methods: {
    async queryOption () {
      const data = {
        id: this.params.id || '',
        name: this.params.name
      }
      const response = await settingCountry.queryOption(data)
      if (response > 0) {
        this.$message.error({
          title: 'Error',
          content: `Country Name already exists!`
        })
      }
    },
    async confirm () {
      const flag = this.$refs['publisher-country-form'].validate()
      if (!flag) {
        return
      }
      if (this.params.id) {
        await settingCountry.edit(this.params.id, this.params)
      } else {
        await settingCountry.add(this.params)
      }
      this.$message.success({
        title: 'Success',
        content: `The Option has been Saved!`
      })

      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message: "Name can not be empty!"
          },
          {
            max: 100,
            message: "Name can not be longer than 100!"
          }
        ],
        otherName: [
          {
            max: 100,
            message: "Other Name can not be longer than 100!"
          }
        ],
      }
    }

  }
}
</script>